import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";

export default class PriceInput extends React.Component {
  state = {
    value: this.props.value
  };

  price = () => this.state.value;

  hasChanged = () => this.state.value !== this.props.value;

  handleChange = event => {
    const { onPriceChange } = this.props;
    this.setState({ value: event.target.value });
    onPriceChange && onPriceChange();
  };

  render() {
    const { showButton, hideInput, onClick, displayValue } = this.props;
    const { value } = this.state;
    return (
      <div className="row no-gutter">
        <div className={showButton ? "col-md-8" : "col-md-12"}>
          {!hideInput && (
            <input
              type="text"
              style={{ padding: 3, height: 25 }}
              className="form-control input-sm"
              onChange={this.handleChange}
              value={value}
            />
          )}
          {hideInput &&
            displayValue && (
              <span>
                <i className="fa fa-sum" />&nbsp;{this.props.value}
              </span>
            )}
        </div>
        {showButton && (
          <div className="col-md-4" style={{ paddingLeft: 5 }}>
            <Button block tiny onClick={onClick} icon="fa-cog" />
          </div>
        )}
      </div>
    );
  }
}
